import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
// @angular/platform-browser-dynamic is deprecated - platformBrowser() (from
// @angular/platform-browser) is the modern replacement, safe here since this app
// is AOT-compiled (no runtime/JIT template compilation to opt into).
import { platformBrowser } from "@angular/platform-browser";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

document.addEventListener("DOMContentLoaded", () => {
  // Angular 21 removed the default ZoneJS change-detection scheduler; without this,
  // async updates (zone.js-triggered events) would no longer schedule change detection.
  // Added automatically by `ng update`'s bootstrap-options-migration schematic.
  platformBrowser()
    .bootstrapModule(AppModule, {
      applicationProviders: [provideZoneChangeDetection()],
    })
    .catch((err) => console.error(err));
});
